var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 24,
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5262 23.8421C16.666 23.8421 15.1578 22.3339 15.1578 20.4737C15.1578 18.6133 16.666 17.1051 18.5262 17.1051H28.6313C30.4917 17.1051 31.9997 18.6133 31.9997 20.4737C31.9997 22.3338 30.4917 23.8421 28.6313 23.8421H18.5262ZM7.02583 12.0528L0.986518 6.0135C-0.329002 4.69816 -0.329002 2.56527 0.986518 1.25007C2.30186 -0.0654523 4.43475 -0.0654523 5.74995 1.25007L14.171 9.6711C15.4865 10.9864 15.4865 13.1191 14.171 14.4345L5.74995 22.8556C4.43461 24.1709 2.30172 24.1709 0.986518 22.8556C-0.329002 21.54 -0.329002 19.4073 0.986518 18.0917L7.02583 12.0528Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.b31a20ff421aa027d0b931b7fb059562.svg";
export { ForwardRef as ReactComponent };